import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/routes/app-routes';
import { AwsService, TranslateService } from '__services';
import { Constants } from '~/app/core/configs/constants';
import { HelperService } from '~/app/core/services';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss', '../login/login.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  isForgotPassword = true;
  isLoading = false;
  hide = true;
  forgotPassForm: FormGroup;
  newPasswordForm: FormGroup;
  errorMsg = '';
  successMsg = '';

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private awsService: AwsService,
    private translationService: TranslateService,
  ) {
    this.forgotPassForm = this.fb.group({
      email: ['',
        [
          Validators.required,
          Validators.pattern(Constants.Validators.PATTERN.email),
          Validators.maxLength(100),
        ],
      ],
    });

    this.newPasswordForm = this.fb.group({
      code: ['', [Validators.required, Validators.maxLength(6)]],
      password: ['', [Validators.required, Validators.maxLength(100)]],
    });
  }

  get newPasswordControl(): any {
    return this.newPasswordForm.controls;
  }
  get forgotPassControl(): any {
    return this.forgotPassForm.controls;
  }

  ngOnInit(): void {}

  sendRequest(): void {
    if (this.forgotPassForm.invalid) {
      return;
    }
    this.isLoading = true;
    this.awsService.sendCode(this.forgotPassControl.email.value).then(
      (res) => {
        this.isLoading = false;
        this.errorMsg = '';
        this.isForgotPassword = false;
        this.newPasswordForm.reset();
      },
      (err) => {
        this.errorMsg = err.message;
        this.isLoading = false;
        this.isForgotPassword = true;
      }
    );

  }

  submitForm(): void {
    if (this.newPasswordForm.invalid) {
      return;
    }
    this.isLoading = true;
    this.awsService
      .resetPassword(
        this.forgotPassControl.email.value,
        this.newPasswordControl.code.value,
        this.newPasswordControl.password.value
      )
      .then(
        () => {
          this.errorMsg = '';
          this.isLoading = false;
          this.router.navigate([APP_ROUTES.LOGIN], { replaceUrl: true });
        },
        (err) => {
          this.errorMsg = err.message;
          this.successMsg = '';
          this.isLoading = false;
        }
      );
  }

  resendCode(): void {
    this.awsService.sendCode(this.forgotPassControl.email.value).then(
      (res) => {
        this.errorMsg = '';
        this.isLoading = false;
        this.successMsg = this.translationService.translate('The code has been resent');
      },
      (err) => {
        this.errorMsg = err.message;
        this.successMsg = '';
        this.isLoading = false;
      }
    );
  }

  getEmailErrorMessage(): string {
    if (this.forgotPassControl.email.hasError('required')) {
      return this.translationService.translate('You must enter a value');
    }
    if (this.forgotPassControl.email.hasError('maxlength')) {
      return this.translationService.translate('Value is over {{char}} character', {
        char: this.forgotPassControl.email.errors.maxlength.requiredLength,
      });
    }

    return this.forgotPassControl.email.hasError('pattern')
      ? this.translationService.translate('Not a valid email')
      : '';
  }

  getCodeErrorMessage(): string {
    if (this.newPasswordControl.code.hasError('required')) {
      return this.translationService.translate('You must enter a value');
    }
    if (this.newPasswordControl.password.hasError('maxlength')) {
      return this.translationService.translate('Value is over {{char}} character', {
        char: this.newPasswordControl.password.errors.maxlength.requiredLength,
      });
    }
  }

  getPasswordErrorMessage(): string {
    if (this.newPasswordControl.password.hasError('required')) {
      return this.translationService.translate('You must enter a value');
    }
    if (this.newPasswordControl.password.hasError('maxlength')) {
      return this.translationService.translate('Value is over {{char}} character', {
        char: this.newPasswordControl.password.errors.maxlength.requiredLength,
      });
    }
  }

  getToday(): string {
    return HelperService.getToday();
  }

  backToLogin(): void {
    this.router.navigate([APP_ROUTES.LOGIN]);
  }

  goBack(): void {
    this.isForgotPassword = true;
    this.errorMsg = '';
    this.successMsg = '';
  }
}
